<template>
    <UModal :model-value="open" @update:model-value="$emit('update:open', $event)">
        <UCard :ui="{ rounded: 'rounded-lg' }">
            <template #header>
                <div class="flex items-center justify-between">
                    <h3 class="text-base font-medium leading-6 text-gray-800">
                        Publish Broadcast
                    </h3>
                    <UButton color="gray" variant="ghost" icon="i-ph-x-bold" class="-my-1" @click="dismiss()" />
                </div>
            </template>
            <div>
                <p>Are you sure you want to publish this broadcast? This will send the notification immediately to all target customers.</p>
            </div>
            <template #footer>
                <div class="flex items-center justify-end space-x-2">
                    <UButton @click="dismiss()" size="lg" color="white">
                        Cancel
                    </UButton>
                    <UButton @click="confirm()" size="lg" :loading="loading" color="black">
                        Publish
                    </UButton>
                </div>
            </template>
        </UCard>
    </UModal>
</template>

<script setup lang="ts">
import type { Broadcast } from '~/types/broadcast'

const emit = defineEmits<{
    'update:open': [boolean]
    'reload': [boolean]
}>()

const props = defineProps<{
    open: boolean
    broadcast?: Broadcast
}>()

const toast = useToast()
const loading = ref<boolean>(false)

async function confirm() {
    if (props.broadcast) {
        loading.value = true

        try {
            await $fetch('/api/broadcasts/publish', {
                method: 'POST',
                body: { id: props.broadcast.id }
            })

            toast.add({
                title: 'Broadcast published successfully!',
                color: 'green',
                icon: 'i-ph-check-circle-duotone'
            })

            dismiss(true)
        } catch (error: any) {
            toast.add({
                title: 'Could not publish this broadcast, please try again later.',
                color: 'red',
                icon: 'i-ph-warning-duotone'
            })
            
            dismiss()
        } finally {
            loading.value = false
        }
    }
}

function dismiss(reload: boolean = false) {
    emit('update:open', false)

    if (reload) {
        emit('reload', true)
    }
}
</script>